import React, { Component } from "react";

import { createStore } from "redux";
import { BrowserRouter as Router, Route } from "react-router-dom";

import "./css/from_starter_kit/sk.main.local.css"
import "./css/App.css";
import "@babel/polyfill";

import cuentas from "./reducers";

import loadable from "@loadable/component";

import Measure from "react-measure";

const PasoInicio = loadable(() => import(/* webpackChunkName: "Inicio" */ "./pages/PasoInicio"));
const PasoIdentidad = loadable(() => import(/* webpackChunkName: "Identidad" */ "./pages/PasoIdentidad"));
const PasoEleccionCuenta = loadable(() => import(/* webpackChunkName: "EleccionCuenta" */ "./pages/PasoEleccionCuenta"));
const PasoOcupacion = loadable(() => import(/* webpackChunkName: "Ocupacion" */ "./pages/PasoOcupacion"));
const Perfilador = loadable(() => import(/* webpackChunkName: "Perfilador" */ "./pages/Perfilador"));
const PasoTerminosyCondiciones = loadable(() => import(/* webpackChunkName: "TerminosCondiciones" */ "./pages/PasoTerminosyCondiciones"));
const PasoTerminosyCondicionesDigital = loadable(() => import(/* webpackChunkName: "TerminosCondiciones" */ "./pages/PasoTerminosyCondicionesDigital"));
const SuccessfulAccount = loadable(() => import(/* webpackChunkName: "SuccessfulAccount" */ "./pages/SuccessfulAccount"));
const SuccessfulAccountDigital = loadable(() => import(/* webpackChunkName: "SuccessfulAccount" */ "./pages/SuccessfulAccountDigital"));
const PaginaError = loadable(() => import(/* webpackChunkName: "Error" */ "./pages/PaginaError"));

// Flujo cuenta Emprendedor:
const PasoInicioCuentaEmprendedor = loadable(() => import(/* webpackChunkName: "InicioCE" */ "./pages/CuentaEmprendedor/PasoInicioCuentaEmprendedor"));
const PasoEleccionCuentaEmprendedor = loadable(() => import(/* webpackChunkName: "EleccionCE" */ "./pages/CuentaEmprendedor/PasoEleccionCuentaEmprendedor"));
const PasoIdentidadCuentaEmprendedor = loadable(() => import(/* webpackChunkName: "IdentidadCE" */ "./pages/CuentaEmprendedor/PasoIdentidadCuentaEmprendedor"));
const PasoOcupacionCuentaEmprendedor = loadable(() => import(/* webpackChunkName: "OcupacionCE" */ "./pages/CuentaEmprendedor/PasoOcupacionCuentaEmprendedor"));
const PasoTerminosyCondicionesCuentaEmprendedor = loadable(() => import(/* webpackChunkName: "TerminosCondicionesCE" */ "./pages/CuentaEmprendedor/PasoTerminosyCondicionesCuentaEmprendedor"));
const PasoFinalCuentaEmprendedor = loadable(() => import(/* webpackChunkName: "FinalCE" */ "./pages/CuentaEmprendedor/PasoFinalCuentaEmprendedor"));
const PaginaErrorCuentaEmprendedor = loadable(() => import(/* webpackChunkName: "ErrorCE" */ "./pages/CuentaEmprendedor/PaginaErrorCuentaEmprendedor"));


let store = createStore(cuentas);

class App extends Component {
  constructor(props) {
    super(props);
    this.calcHeight = this.calcHeight.bind(this);
    this.state = {
      dimensions: {
        width: -1,
        height: -1,
      },
    };
  }

  render() {

    let CONTEXT = '/cuentas/react/';
    let contexAjax = '/cuentas/';

    if (window.location.host === 'cuentas.bbva.pe' || window.location.host === 'cuentaemprendedor.bbva.pe') {
      CONTEXT = '/react/';
      contexAjax = '/';
    } else if (window.location.pathname.indexOf('/cuentas/cuenta-emprendedor/react') > -1) {
      CONTEXT = '/cuentas/cuenta-emprendedor/react/';
      contexAjax = '/cuentas/';
    } else {
      let contextParent = window.parent.location.pathname;
      CONTEXT = '/' + contextParent.split('/')[1] + '/react/';
      contexAjax = '/' + contextParent.split('/')[1] + '/';
    }

    return (
      <Measure
        bounds
        onResize={(contentRect) => {
          this.setState({ dimensions: contentRect.bounds });
          this.calcHeight(contentRect.bounds.height);
        }}
      >
        {({ measureRef }) => (
          <div style={divApp} ref={measureRef}>
            <Router>
              <div>
                <Router>
                  <div>
                    <Route exact path={CONTEXT} render={(props) => <PasoInicio {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route path={CONTEXT + "pasoEleccionCuenta"} render={(props) => <PasoEleccionCuenta {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route path={CONTEXT + "pasoIdentidad"} render={(props) => <PasoIdentidad {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route path={CONTEXT + "pasoOcupacion"} render={(props) => <PasoOcupacion {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route path={CONTEXT + "perfilador"} render={(props) => <Perfilador {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route path={CONTEXT + "terminos-y-condiciones"} render={(props) => <PasoTerminosyCondiciones {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route path={CONTEXT + "terminos-y-condiciones-digital"} render={(props) => <PasoTerminosyCondicionesDigital {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route path={CONTEXT + "pasoFin"} render={(props) => <SuccessfulAccount {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route path={CONTEXT + "pasoFinDigital"} render={(props) => <SuccessfulAccountDigital {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route path={CONTEXT + "error"} render={(props) => <PaginaError {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />

                    {/* Flujo Cuenta Emprendedor */}
                    <Route exact path={CONTEXT + "inicioCE"} render={(props) => <PasoInicioCuentaEmprendedor {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route path={CONTEXT + "pasoEleccionCE"} render={(props) => <PasoEleccionCuentaEmprendedor {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route exact path={CONTEXT + "pasoIdentidadCE"} render={(props) => <PasoIdentidadCuentaEmprendedor {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route path={CONTEXT + "pasoOcupacionCE"} render={(props) => <PasoOcupacionCuentaEmprendedor {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route exact path={CONTEXT + "pasoTerminosCE"} render={(props) => <PasoTerminosyCondicionesCuentaEmprendedor {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route path={CONTEXT + "pasoFinalCE"} render={(props) => <PasoFinalCuentaEmprendedor {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                    <Route path={CONTEXT + "paginaErrorCE"} render={(props) => <PaginaErrorCuentaEmprendedor {...props} store={store} contexto={CONTEXT} contexAjax={contexAjax} />} />
                  </div>
                </Router>
              </div>
            </Router>
          </div>
        )}
      </Measure>
    );
  }

  calcHeight(height) {
    let inIframeReact = function () {
      return window.self !== window.top;
    };

    let inAem = function () {
      return window.parent.self !== window.parent.top;
    };

    if (inIframeReact()) {
      window.parent.frames["iframeCuentasReact"].style.height = height + "px";
    }

    if (inAem()) {
      window.parent.frames["iframeCuentasReact"].style.height = height + "px";
    }
  }
}

const divApp = {
  margin: "auto",
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js